/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="thumbnail-wrapper">\n  ';
 if(data.model.isSpecialFolder()) { ;
__p += '\n    <img class="folder-img" src="https://d3jozdooylvm2p.cloudfront.net/images/icons/media-folder_purp.png"/>\n  ';
 } else { ;
__p += '\n    <img class="folder-img" src="https://d3jozdooylvm2p.cloudfront.net/images/icons/media-folder_blue.png"/>\n  ';
 } ;
__p += '\n</div>\n<div class="item-filename">\n  ' +
__e(data.model.get('name')) +
'\n</div>';
return __p
}
